import React from "react";
import { AppPage } from "../components";

export const LoadingPage = (): JSX.Element => <AppPage>{null}</AppPage>;
